import { useUploadContacts } from './contacts';

export const CONTEXT_TYPE = {
  CONTACTS: 'contacts',
  // Future types can be added here:
  // USERS: 'users',
  // ROTATIONS: 'rotations',
  // METRICS: 'metrics',
};

export function useUploadContextFactory({ contextType = CONTEXT_TYPE.CONTACTS }) {
  const contactsContext = useUploadContacts();

  if (contextType === CONTEXT_TYPE.CONTACTS) {
    return contactsContext;
  }

  // Future context types can be added here
  // if (contextType === CONTEXT_TYPE.USERS) {
  //   return usersContext;
  // }

  return contactsContext; // Default fallback
}
